// @flow

import React, {
  // $FlowFixMe
  useMemo
} from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import PotencialReturnHelp from "@fdr/atomic-ui/_templates/PotencialReturnHelp";
import { parseJSONCapiMessage } from "@fdr/utils/parseJSONCapiMessage";

type Props = {
  potencialReturnMessage: {
    paraf1: string,
    paraf2: string,
    paraf3: string,
    info: string
  },
  hasMessage: boolean
};

export const PotencialReturnHelpComp = ({
  hasMessage,
  potencialReturnMessage
}: Props) =>
  useMemo(
    () => (
      <PotencialReturnHelp
        paraf1={potencialReturnMessage.paraf1}
        paraf2={potencialReturnMessage.paraf2}
        paraf3={potencialReturnMessage.paraf3}
        infoMessage={potencialReturnMessage.info}
        hasMessage={hasMessage} // this comes from the modal in fdr-mobile/src/shared/pages/components/modals
      />
    ),
    [potencialReturnMessage, hasMessage]
  );

PotencialReturnHelpComp.defaultProps = {
  potencialReturnMessage: { paraf1: "", paraf2: "", paraf3: "", info: "" },
  hasMessage: false
};

export default connect((store) => ({
  potencialReturnMessage: parseJSONCapiMessage(
    get(store, "capi.messages"),
    "potencialReturnHelp",
    { paraf1: "", paraf2: "", paraf3: "", info: "" }
  )
}))(PotencialReturnHelpComp);
